import React, { useState } from "react";

import "../../assets/css/mission-details.css";

import DetailsMission from "../../components/mission/detailsMission.jsx";
import NavBar from "../../components/general/NavBarApp.jsx";
import {useNavigate} from "react-router-dom";

const MissionDetail = () => {
  return (
    <div className="main">
      <NavBar />

      {/*<DetailsMission/> */}

      {/*<DetailsMission
            mode="particulier"
            particulierStatus="proposition"
            onAccept={handleClick}
            />

      {/*<DetailsMission
            mode="particulier"
            particulierStatus="encours"
            />*/}

      <DetailsMission mode="particulier" particulierStatus="offre" />
    </div>
  );
};

export default MissionDetail;
